// Firebase Auth errors: server codes the SDK 8 does not know and their texts on screen

// With email enumeration protection on, a wrong e-mail or password comes as INVALID_LOGIN_CREDENTIALS,
// which the SDK 8 wraps in auth/internal-error with the server response as the message
const SERVER_CODES = {
  INVALID_LOGIN_CREDENTIALS: 'auth/invalid-login-credentials',
};

// Same error with the code of a known server response instead of auth/internal-error
export function normalizeAuthError(error) {
  if (error && error.code === 'auth/internal-error') {
    const serverCode = Object.keys(SERVER_CODES).find((key) => String(error.message || '').includes(key));
    if (serverCode) {
      error.code = SERVER_CODES[serverCode];
    }
  }
  return error;
}

// Translated text of an auth error code, or the generic login error when the code has no translation
export function authErrorText(vm, code) {
  const key = `login.providerCode.${code}`;
  return vm.$te(key) ? vm.$t(key) : vm.$t('login.error.generic');
}
